import React, { useEffect, useState } from 'react';
import DialogContent from '@mui/material/DialogContent';
import ButtonRound from '../ButtonRound';
import styles from './Modal.scss';
import useUser from '../../stores/useUser';
import { IModalProps } from './Modal';

export interface ISuccessProps extends IModalProps {
    values: any;
    formElement?: any;
    code: string;
    salt: string;
}

const Success: React.FC<React.PropsWithChildren<ISuccessProps>> = ({ isLoading, onSubmitAction, formElement = 'form', submitButtonText, successText, salt, code }) => {
    const [user] = useUser();
    const FormElement = formElement;
    const formProps = {
        onSubmit: () => {
            onSubmitAction(salt, code);
        },
    };

    return (
        <div>
            <DialogContent dividers={false}>
                <FormElement {...formProps}>
                    <p><b>Deine Verifizierung war erfolgreich!</b></p>
                    <p>{successText ? successText : "Du kannst dich nun registrieren."}</p>
                    <div className={styles.publishButtons}>
                        <ButtonRound
                            onClick={() => {
                                onSubmitAction(salt, code);
                            }}
                            disabled={isLoading}
                            type="submit"
                            isLoading={isLoading}
                        >
                            {submitButtonText ? submitButtonText : "Registrierung abschließen"}
                        </ButtonRound>
                    </div>
                </FormElement>
            </DialogContent>
        </div>
    )
}

export default Success;